import axiosClient from "../axiosClient"
import streamingClient from "../streamingClient"

export const recordApi = {
    post: (data) => {
        return streamingClient.post("/recordManagement/post-start-recording/", data)
    },
    stop: (data) => {
        return streamingClient.post("/recordManagement/post-stop-recording/", data)
    },
    changeStatus: (data) => {
        const {camera_code,...rest} = data
        return axiosClient.put(`recordConfig/put-change-status-record-config/?camera_code=${camera_code}`,rest)
    },
    configRecord:(data)=>{
        return streamingClient.post('/recordManagement/post-update-config-cleaning-record/',data)
    },
    setDefaultConfig:(data)=>{
        return streamingClient.delete(`/recordManagement/delete-config-cleaning-record/?camera_id=${data}`)
    },
    getRecordConfig:(data)=>{
        return streamingClient.get( `/recordManagement/get-config-cleaning-record/?camera_id=${data}`)
    },
    updateRestream:(data)=>{
        return streamingClient.put( `/streamManagement/put-update-restream-camera/`,data)
    },
    getRecordQualityConfig: (params) => {
        return axiosClient.get('/recordConfig/get-list-record-config/', {
            params: params
        })
    }
}